import React, { useEffect, useState } from 'react'
import { Button, Grid, Typography } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { useTranslation } from 'react-i18next';
import { SuccessIcon, ErrorIcon } from '../../components/CustomIcons';
import CustomHeader from '../../components/CustomHeader';
import wsclients from '../../services/wsclients';
import { paths } from '../../config/router.config';
import { useHistory } from 'react-router-dom';
import CustomAlert from '../../components/CustomAlert';
import CustomLoading from '../../components/CustomLoading';

const useStyles = makeStyles((theme) => ({
    content: {
        padding: theme.spacing(2),
        paddingTop: theme.spacing(10),
        textAlign: 'center',
    },
}));

export default function ChangeServiceResult(props) {
    const classes = useStyles();
    const { t } = useTranslation();
    const history = useHistory();

    const [showLoading, onShowLoading] = useState(false);
    const [message, setMessage] = useState(null);
    const [result, setResult] = useState(null);
    const [contact, setContact] = useState(null);

    useEffect(() => {
        onLoad();
    }, []);

    const onLoad = async () => {
        onShowLoading(true)
        let contact_info = await onLoadContact();
        //url: http://localhost:3001/registerorders-result?payment_id=206e9abe-daae-4e99-bdd8-46bfcbd0eea0&order_id=VR-250522-45473&result=success
        var url = new URL(window.location.href);
        console.log("url===", url);
        var payment_id = url.searchParams.get("payment_id");
        var order_id = url.searchParams.get("order_id");
        var status = url.searchParams.get("result");
        console.log("payment_id==", payment_id);
        console.log("order_id==", order_id);
        console.log("result==", status);

        var orderResult = {
            payment_id: payment_id,
            order_id: order_id,
            status: status,
            contact_id: contact_info && contact_info.id ? contact_info.id : null,
            message: null
        };
        console.log("change service result==", orderResult);
        await onUpdateOrderStatus(orderResult);
        setResult(orderResult);
        onShowLoading(false)
    }

    const onLoadContact = async () => {
        let contact_info = null;
        try {
            var resutl = await wsclients.contacts.getContact();
            if (resutl.code === 'OK') {
                contact_info = resutl.data;
                setContact(resutl.data);
            }
        } catch (ex) {
            console.log("onLoadContact exception===", ex);
        }
        return contact_info;
    }

    const onUpdateOrderStatus = async (order_result) => {
        try {
            var result = await wsclients.lab4services.updateOrderStatus({
                contact_id: order_result.contact_id,
                order_id: order_result.order_id,
                result: order_result.status,
            });
            let mess = t('UPDATE_STATUS_ORDER');
            // if (order_result.status === 'success') mess += ". " + t('PAYMENT_SUCCESS');
            // else mess += t('PAYMENT_FAILED');
            if (result.code === 'OK') {
                setMessage(mess);
            } else {
                setMessage(mess);
            }
        }
        catch (ex) {
            console.log("onUpdateOrderStatus exception===", ex);
        }
    }

    const onShowMessage = (message) => {
        onShowLoading(false)
        setMessage(message)
    }

    return (
        <Grid item xs={12}>
            <CustomHeader hideMenu={true} nomargin={true} />
            <Grid xs={12} item container justifyContent='center' className={classes.content}>
                <Grid xs={12} item container justifyContent='center' marginTop={4}>
                    {result && result.status === 'success' && <SuccessIcon style={{ fontSize: 50 }} />}
                    {result && result.status === 'failed' && <ErrorIcon style={{ fontSize: 50 }} />}
                </Grid>
                <Grid xs={12} item container justifyContent='center' marginTop={4}>
                    {result && result.status === 'success' && <Grid item xs={12}>
                        <Typography variant='body2'>{t('PAYMENT_SUCCESS')}</Typography>
                        {message && <Typography variant='body2'>{message}</Typography>}
                    </Grid>}
                    {result && result.status === 'failure' && <Grid item xs={12}>
                        <Typography variant='body2'>{t('PAYMENT_FAILED')}</Typography>
                        {/* {message && <Typography variant='body2'>{message}</Typography>} */}
                    </Grid>}
                </Grid>
                <Grid xs={12} item container justifyContent='center' marginTop={4}>
                    <Button variant='contained' onClick={() => history.push(paths.home)}>{t('btn_back_to_home')}</Button>
                </Grid>
            </Grid>
            {showLoading && <CustomLoading open={showLoading} />}
            {/* {message && message.show && <CustomAlert
                open={message.show}
                message={message.content}
                showButtonClose={true}
                onClose={message.action ? message.action : () => onShowMessage({})}
            />} */}
        </Grid>
    );
}